const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:3000';

async function adminRequest<T>(
  path: string,
  options: RequestInit = {},
  token: string,
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    ...((options.headers as Record<string, string>) ?? {}),
  };

  const response = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: response.statusText }));
    throw new Error(error.message || `Request failed with status ${response.status}`);
  }

  if (response.status === 204) return undefined as T;
  return response.json();
}

export function getOverviewStats(token: string) {
  return adminRequest<any>('/admin/stats/overview', {}, token);
}

export function getSignupsPerWeek(token: string) {
  return adminRequest<any[]>('/admin/stats/signups-per-week', {}, token);
}

export function getSharesPerDay(token: string) {
  return adminRequest<any[]>('/admin/stats/shares-per-day', {}, token);
}

export function getAdminUsers(token: string, params: Record<string, string> = {}) {
  const qs = new URLSearchParams(params).toString();
  return adminRequest<any>(`/admin/users${qs ? `?${qs}` : ''}`, {}, token);
}

export function getAdminUserDetail(token: string, userId: string) {
  return adminRequest<any>(`/admin/users/${userId}`, {}, token);
}

export function blockUser(token: string, userId: string) {
  return adminRequest<any>(`/admin/users/${userId}/block`, { method: 'PATCH' }, token);
}

export function unblockUser(token: string, userId: string) {
  return adminRequest<any>(`/admin/users/${userId}/unblock`, { method: 'PATCH' }, token);
}

export function deleteUser(token: string, userId: string) {
  return adminRequest<void>(`/admin/users/${userId}`, { method: 'DELETE' }, token);
}

export function getAdminSubscriptions(token: string, params: Record<string, string> = {}) {
  const qs = new URLSearchParams(params).toString();
  return adminRequest<any>(`/admin/subscriptions${qs ? `?${qs}` : ''}`, {}, token);
}

export function getSubscriptionMetrics(token: string) {
  return adminRequest<any>('/admin/subscriptions/metrics', {}, token);
}

export function grantPro(token: string, userId: string) {
  return adminRequest<any>(`/admin/subscriptions/${userId}/grant-pro`, { method: 'PATCH' }, token);
}

export function revokePro(token: string, userId: string) {
  return adminRequest<any>(`/admin/subscriptions/${userId}/revoke-pro`, { method: 'PATCH' }, token);
}
